<template>
	<div class="tx-lt pd-tb-10">
		<i class="el-icon-back clr-4fb cursor-p" style="font-size: 40px;" @click="goBack"></i>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			
			};
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			goBack(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style>
</style>